import avatar from '../assets/img/boy-avatar-smiling.jpg'
export const imageSources = [
  avatar,
  avatar,
  avatar,
  avatar,
  avatar,
];